
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[code]",
      function () {
        return require("private-next-pages/r/[code].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[code]"])
      });
    }
  